import type { Feature } from '@luna/gatekeeper';

export const topUp: Feature = {
    enabled: false,
    _description: 'Enables top up focus page',
};
